<template>
  <v-container class="px-0">
    <!--
    {{ this.markers }}
    -->
    <template v-if="mode === 'edit'">
      <!--edit fields and buttons-->
      <gmap-autocomplete
        class="introInput"
        @place_changed="setPlace"
        :select-first-on-enter="true"
        :options="gmapAutoCompleteOptions"
      >
        <template v-slot:input="slotProps">
          <v-text-field
            outlined
            :label="label"
            placeholder="Ange adress"
            ref="input"
            v-on:listeners="slotProps.listeners"
            clearable
            v-model="addressSearchInput"
          >
          </v-text-field>
        </template>
      </gmap-autocomplete>
      <div class="mb-6">
        <v-btn
          class="mr-4"
          v-for="(addMarkerButton, index) in addMarkerButtons"
          :key="index"
          color="secondary"
          @click="addMarker(addMarkerButton.label)"
        >
          {{ addMarkerButton.text }}
        </v-btn>
      </div>
    </template>
    <template v-if="mode == 'edit'">
      <div class="pb-4">
        <div
          class="text-body-1 pb-2"
          v-for="(marker, index) in markers"
          :key="index"
          :class="{ 'addressIsOk' : data[marker.label + '_name'].length }"
        >
          <v-icon
            v-if="data[marker.label + '_name'].length == 0"
            color="error"
            class="mr-2"
          >
            mdi-close
          </v-icon>
          <v-icon
            v-if="data[marker.label + '_name'].length != 0"
            color="accent"
            class="mr-2"
          >
            mdi-check
          </v-icon>
          <span class="font-weight-bold">{{ marker.name }}:</span> {{ data[marker.label + '_name'] }}
        </div>
      </div>
    </template>
    <gmap-map
      v-if="useMap"
      :center="center"
      :zoom="12"
      ref="mapRef"
      style="width:100%; height:400px;"
      :options="mapOptions"
    >
      <gmap-marker
        v-for="(marker, index) in markersWithPosition"
        :key="index"
        :position="marker.position"
        :icon="marker.icon"
      ></gmap-marker>
    </gmap-map>
    <!--
    <v-btn
      @click="fitBounds()"
    >
      fitBounds
    </v-btn>
    -->
  </v-container>  
</template>

<script>
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { googleMapMixin } from '../mixins/googleMap'
import { snackBarBus } from '../main'
//import { gmapApi } from 'gmap-vue'
export default {
  props: {
    markers: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      default: 'edit'
    },
    label: {
      type: String,
      default: 'Sök på adress'
    },
    data: {
      type: Object,
      required: true
    },
    addMarkerButtons: {
      type: Array,
      required: false
    },
    useMap: {
      type: Boolean,
      default: true
    }
  },
  mixins: [generalMixin, urlMixin, googleMapMixin],
  data() {
    return {
      debug: false,
      checkMapTimeout: null,
      center: { lat: 59.32, lng: 18.07 },
      gmapAutoCompleteOptions: {
        //restrict searches to some countries
//        componentRestrictions: {country: ['se', 'dk', 'no', 'fi'] }
      },
      addressSearchInput: '',
      mapIsMounted: false,
      map: null,
      mapCheckCounter: 0,
      maxMapCheckCount: 100,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUI: false,
        styles: [
          {
            featureType: "poi",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "transit",
            stylers: [{ visibility: "off" }]
          }
        ]
      }
    }
  },
  watch: {
    mapIsMountedAndHasMarkers(value) {
      this.log('watch mapIsMountedAndHasMarkers', value)
      if (value) {
        this.fitBounds()
      }
    }
  },
  computed: {
    markersWithPosition() {
      let vm = this
      let markers = this.markers.filter(function(marker) { return vm.isValidCoordinate(marker.position) })
//      this.log('markersWithPosition', markers)
      return markers
    },
    mapIsMountedAndHasMarkers() {
      let value = this.markers.length && this.mapIsMounted
      this.log("computed mapIsMountedAndHasMarkers", value)
      return value
    },
//    google: gmapApi,
  },
  methods: {
    log(a,b) {
      if (this.debug) {
        console.log(a, b)
      }
    },
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place
    },
    addMarker(label) {
      let position = null
      if (this.currentPlace && this.currentPlace.geometry) {
        position = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        }
        //get array index of label
        let index = this.markers.findIndex(marker => marker.label == label)
        this.log('index', index)
        //reset position for marker
        this.markers[index].position = position
        if (this.useMap) {
          this.fitBounds()
        }
      }
      let name = this.currentPlace ? this.currentPlace.formatted_address : ''
      if (!position) {
        snackBarBus.$emit('message', 'Var god sök upp och välj en address i listan')
      } else {
        this.data[label] = position
        this.data[label + '_name'] = name
      }
      this.currentPlace = null
      this.addressSearchInput = ''
    },
    onIsMountedAndViewDataIsLoaded() {
      this.log("onIsMountedAndViewDataIsLoaded")
//      this.$nextTick(() => {
      if (this.markersWithPosition.length) {
        //make sure map shows marker/s
        this.fitBounds()
      } else {
        //when no markers, geolocate to center
        this.geolocate()
      }
//      })
    },
    fitBounds() {
//      this.log("fitBounds markersWithPosition", this.markersWithPosition)
      //fit all markers in view
      let bounds, offsetx, offsety, latlng, scale, worldCoordinateCenter, pixelOffset, worldCoordinateNewCenter, newCenter
      switch (this.markersWithPosition.length) {
        case 0:
//          this.log("no markers")
          break
        case 1:
          this.center = this.markersWithPosition[0].position
//          this.log("single marker - center", this.center)
          break
        default:
//          this.log("multiple markers - do bound")
          bounds = new window.google.maps.LatLngBounds()
          for (let marker of this.markersWithPosition) {
//            this.log("bounds extend", marker.position)
            bounds.extend(marker.position)
          }
          this.map.fitBounds(bounds)
          //offset center some pixels up, in order to be sure entire top positioned marker icon is visible
          // latlng is the apparent centre-point
          // offsetx is the distance you want that point to move to the right, in pixels
          // offsety is the distance you want that point to move upwards, in pixels
          // offset can be negative
          // offsetx and offsety are both optional
          offsetx = 0
          offsety = -35
          latlng = this.map.getCenter()
          scale = Math.pow(2, this.map.getZoom())
          worldCoordinateCenter = this.map.getProjection().fromLatLngToPoint(latlng)
          pixelOffset = new window.google.maps.Point(
            (offsetx/scale) || 0,
            (offsety/scale) || 0
          )
          worldCoordinateNewCenter = new window.google.maps.Point(
            worldCoordinateCenter.x - pixelOffset.x,
            worldCoordinateCenter.y + pixelOffset.y
          )
          newCenter = this.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
          this.center = newCenter;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    },
    checkForMapMounted() {
      this.mapCheckCounter++
      if (this.mapCheckCounter > this.maxMapCheckCount) {
        this.log('checkForMapMounted gave up')
        return
      }
      let mapIsMounted = (this.$refs.mapRef && window.google && window.google.maps);
      this.log('checkForMapMounted', mapIsMounted)
      if (mapIsMounted) {
        //the ref and window.google exists, now try to get map
        this.$refs.mapRef.$mapPromise.then((map) => {
          //we also need getProjection, so check for it
          let hasProjection = (map.getProjection())
          this.log('checkForMapMounted getProjection', hasProjection)
          if (hasProjection) {
            this.map = map;
            this.mapIsMounted = true
          } else {
            //check again
            this.checkMapTimeout = setTimeout(this.checkForMapMounted, 250)
          }
        })
      } else {
        //check again
        this.checkMapTimeout = setTimeout(this.checkForMapMounted, 250)
      }
    },
  },
  mounted() {
    this.checkForMapMounted()
  },
  created() {
    this.log('created - markers:', this.markers)
  },
  destroyed() {
    this.trace('GoogleMap destroyed')
    if (this.checkMapTimeout) {
      clearTimeout(this.checkMapTimeout)
      this.trace('checkMapTimeout cleared')
    }
  }
}
</script>

<style>
</style>